import * as tslib_1 from "tslib";
import { moveItemInArray, transferArrayItem, } from "@angular/cdk/drag-drop";
import { OnDestroy, OnInit } from "@angular/core";
import { Validators } from "@angular/forms";
import * as _ from "lodash";
import { Subscription } from "rxjs";
import { Alert } from "src/app/shared/class/Alert";
import { globalConst } from "src/app/shared/helpers/constants";
export class UserDetailsComponent {
    constructor(route, router, userService, spinner, fb, serviceRequestService) {
        this.route = route;
        this.router = router;
        this.userService = userService;
        this.spinner = spinner;
        this.fb = fb;
        this.serviceRequestService = serviceRequestService;
        this.goback = "../list/";
        this.subscription = new Subscription();
        this.itemsPerPage = 5;
        this.currentPage = 1;
        this.queryParams = {};
        this.userLoaded = {};
        this.hidePassword = true;
        this.hideConfirmPassword = true;
        this.optionsUserType = globalConst.options.userTypes;
        this.companiesAvailable = [];
        this.companiesAssociate = [];
        this.regionalsAvailable = [];
        this.regionalsAssociate = [];
        this.serviceLocalsAvailable = [];
        this.serviceLocalsAssociate = [];
    }
    ngOnInit() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                this.spinner.show();
                this.userForm = this.fb.group({
                    type: this.fb.control(null, [Validators.required]),
                    name: this.fb.control("", [Validators.required]),
                    username: this.fb.control("", [Validators.required]),
                    email: this.fb.control("", [Validators.required, Validators.email]),
                    phone: this.fb.control(""),
                    function: this.fb.control(""),
                    active: this.fb.control(true, [Validators.required]),
                    password: this.fb.control("", [
                        Validators.required,
                        Validators.minLength(6),
                    ]),
                    confirmPassword: this.fb.control("", [
                        Validators.required,
                        Validators.minLength(6),
                    ]),
                }, { validator: this.checkPassword });
                this.route.queryParams.subscribe((params) => (this.queryParams = params));
                yield this.load();
                yield this.loadCompanies();
                yield this.loadRegionals();
                yield this.loadServiceLocals();
                yield this.treatAssociations();
                this.userForm.controls.type.valueChanges.subscribe(() => {
                    if (!this.userForm.controls.type.errors) {
                        _.map(this.companiesAssociate, (company) => {
                            this.companiesAvailable.push(company);
                        });
                        this.companiesAssociate = [];
                    }
                });
                this.spinner.hide();
            }
            catch (error) {
                console.error(error);
                this.spinner.hide();
            }
        });
    }
    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
    dropCompany(event) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (event.previousContainer === event.container) {
                moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
            }
            else {
                this.spinner.show();
                transferArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);
                yield this.reloadCompanyOptions();
                yield this.reloadRegionalOptions();
                this.spinner.hide();
            }
        });
    }
    reloadCompanyOptions() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const newRegionalsAvailable = [];
            const newRegionalsAssociate = [];
            yield this.loadRegionals();
            this.companiesAssociate.map((company) => {
                this.companiesAvailable = this.companiesAvailable.filter((obj) => obj.id !== company.id);
                this.regionalsAvailable
                    .filter((obj) => obj.companyAlternativeIdentifier === company.alternativeIdentifier)
                    .map((regional) => {
                    newRegionalsAvailable.push(regional);
                });
                this.regionalsAssociate
                    .filter((obj) => obj.companyAlternativeIdentifier === company.alternativeIdentifier)
                    .map((regional) => {
                    newRegionalsAssociate.push(regional);
                });
                newRegionalsAvailable.sort((a, b) => a.description > b.description ? 1 : -1);
                newRegionalsAssociate.sort((a, b) => a.description > b.description ? 1 : -1);
            });
            this.regionalsAssociate = newRegionalsAssociate;
            const regionalsToShow = [];
            newRegionalsAvailable.map((newRegional) => {
                const found = this.regionalsAssociate.filter((obj) => obj.id === newRegional.id);
                if (_.isEmpty(found)) {
                    regionalsToShow.push(newRegional);
                }
            });
            this.regionalsAvailable = regionalsToShow;
        });
    }
    dropRegional(event) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (event.previousContainer === event.container) {
                moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
            }
            else {
                this.spinner.show();
                transferArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);
                yield this.reloadRegionalOptions();
                this.spinner.hide();
            }
        });
    }
    reloadRegionalOptions() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.loadServiceLocals();
            const newServiceLocalsAvailable = [];
            const newServiceLocalsAssociate = [];
            this.regionalsAssociate.map((regionalAssociate) => {
                const foundAvailable = this.serviceLocalsAvailable.filter((obj) => obj.regionalId === regionalAssociate.id);
                foundAvailable.map((found) => newServiceLocalsAvailable.push(found));
                this.serviceLocalsAssociate
                    .filter((obj) => obj.regionalId === regionalAssociate.id)
                    .map((serviceLocal) => {
                    newServiceLocalsAssociate.push(serviceLocal);
                });
                newServiceLocalsAvailable.sort((a, b) => a.description > b.description ? 1 : -1);
                newServiceLocalsAssociate.sort((a, b) => a.description > b.description ? 1 : -1);
            });
            this.serviceLocalsAssociate = newServiceLocalsAssociate;
            this.serviceLocalsAvailable = newServiceLocalsAvailable;
        });
    }
    drop(event) {
        if (event.previousContainer === event.container) {
            moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
        }
        else {
            transferArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);
        }
    }
    treatAssociations() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.queryParams.id) {
                this.companiesAssociate = this.userLoaded.companiesAssociate;
                yield this.reloadCompanyOptions();
                this.regionalsAssociate = this.userLoaded.regionalsAssociate;
                this.regionalsAssociate.map((regional) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                    this.regionalsAvailable = this.regionalsAvailable.filter((obj) => obj.id !== regional.id);
                }));
                this.serviceLocalsAssociate = this.userLoaded.serviceLocalsAssociate;
                this.serviceLocalsAssociate.map((serviceLocal) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                    this.serviceLocalsAvailable = this.serviceLocalsAvailable.filter((obj) => obj.id !== serviceLocal.id);
                }));
            }
        });
    }
    filterItems() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.companiesAssociate.length > 0) {
                this.spinner.show();
                this.regionalsAvailable = [];
                yield this.loadRegionals();
                this.companiesAssociate.map((company) => {
                    this.regionalsAvailable.filter((obj) => obj.companyAlternativeIdentifier === company.alternativeIdentifier);
                });
                this.spinner.hide();
            }
        });
    }
    loadCompanies() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const data = yield this.serviceRequestService.getCompanies();
            this.companiesAvailable = data.status === undefined ? data : [];
            this.companiesAvailable.sort((a, b) => a.description > b.description ? 1 : -1);
        });
    }
    loadRegionals() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const data = yield this.serviceRequestService.getRegionals();
            this.regionalsAvailable = data.status === undefined ? data : [];
            this.regionalsAvailable.sort((a, b) => a.description > b.description ? 1 : -1);
        });
    }
    loadServiceLocals() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const data = yield this.serviceRequestService.getServiceLocals();
            this.serviceLocalsAvailable = data.status === undefined ? data : [];
            this.serviceLocalsAvailable.sort((a, b) => a.description > b.description ? 1 : -1);
        });
    }
    load() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.queryParams.id) {
                this.spinner.show();
                try {
                    this.userForm.get("password").clearValidators();
                    this.userForm.get("confirmPassword").clearValidators();
                    const data = yield this.userService.searchUser(this.queryParams.id);
                    this.userLoaded = data.status === undefined ? data : {};
                    this.userForm.setValue(Object.assign({}, this.userForm.value, { type: this.userLoaded.type, name: this.userLoaded.name, username: this.userLoaded.username, email: this.userLoaded.email, active: this.userLoaded.active }));
                }
                catch (error) {
                    this.spinner.hide();
                    Alert.error(Alert.getMessage().errors.load).then(() => this.router.navigate(["/user/list"]));
                }
            }
        });
    }
    loadFormData() {
        this.spinner.show();
        this.userForm.setValue(Object.assign({}, this.userForm.value));
        this.spinner.hide();
    }
    onSubmit() {
        if (this.userForm.valid) {
            if (!this.queryParams.id) {
                this.save();
            }
            else {
                this.update();
            }
        }
        else {
            this.userForm.markAllAsTouched();
        }
    }
    save() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.spinner.show();
            const data = Object.assign({}, this.userForm.value, { companiesAssociate: this.companiesAssociate, regionalsAssociate: this.regionalsAssociate, serviceLocalsAssociate: this.serviceLocalsAssociate });
            delete data.confirmPassword;
            const userExist = yield this.checkUserId();
            if (parseInt(userExist, 10) === 0) {
                this.subscription.add(this.userService.registerUser(Object.assign({}, data)).subscribe(() => {
                    this.spinner.hide();
                    Alert.success(Alert.getMessage().success.save).then(() => this.router.navigate(["/user/list"]));
                }, () => {
                    this.spinner.hide();
                    Alert.error(Alert.getMessage().errors.save);
                }));
            }
            else {
                this.spinner.hide();
                Alert.error(Alert.getMessage().errors.user.userExist).then(() => {
                    document.getElementById("username").focus();
                });
            }
        });
    }
    update() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            Alert.question(Alert.getMessage().question.update).then((response) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                if (response.value) {
                    this.spinner.show();
                    const data = Object.assign({}, this.userForm.value, { id: this.queryParams.id, companiesAssociate: this.companiesAssociate, regionalsAssociate: this.regionalsAssociate, serviceLocalsAssociate: this.serviceLocalsAssociate });
                    delete data.confirmPassword;
                    this.subscription.add(this.userService.updateUser(Object.assign({}, data)).subscribe(() => {
                        this.spinner.hide();
                        Alert.success(Alert.getMessage().success.update).then(() => this.router.navigate(["/user/list"]));
                    }, () => {
                        this.spinner.hide();
                        Alert.error(Alert.getMessage().errors.update);
                    }));
                }
            }));
        });
    }
    checkUserId() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.spinner.show();
            const queryParams = `?username=${this.userForm.controls.username.value}&count=true`;
            const request = yield this.userService.searchUserFull(queryParams);
            this.spinner.hide();
            return request.total;
        });
    }
    delete() {
        Alert.question(Alert.getMessage().question.delete).then((response) => {
            if (response.value) {
                this.subscription.add(this.userService.deleteUser(this.queryParams.id).subscribe(() => Alert.success(Alert.getMessage().success.delete).then(() => this.router.navigate(["/user/list"])), () => Alert.error(Alert.getMessage().errors.delete)));
            }
        });
    }
    changePassword() {
        this.router.navigate(["/user/pass"], {
            queryParams: { id: this.queryParams.id },
        });
    }
    checkPassword(group) {
        const password = group.controls.password.value;
        const confirmPassword = group.controls.confirmPassword.value;
        if (password !== confirmPassword) {
            group.controls.confirmPassword.setErrors(Object.assign({}, group.controls.confirmPassword.errors, { confirmPassword: true }));
        }
        else if (password === confirmPassword &&
            group.controls.confirmPassword.hasError("confirmPassword")) {
            delete group.controls.confirmPassword.errors.match;
            group.controls.confirmPassword.updateValueAndValidity();
        }
    }
    associateAllCompany() {
        this.companiesAvailable.map((company) => {
            this.companiesAssociate.push(company);
        });
        this.companiesAvailable = [];
    }
    desassociateAllCompany() {
        this.companiesAssociate.map((company) => {
            this.companiesAvailable.push(company);
        });
        this.companiesAssociate = [];
    }
    associateAllRegional() {
        this.regionalsAvailable.map((regional) => {
            this.regionalsAssociate.push(regional);
        });
        this.regionalsAvailable = [];
    }
    desassociateAllRegional() {
        this.regionalsAssociate.map((regional) => {
            this.regionalsAvailable.push(regional);
        });
        this.regionalsAssociate = [];
    }
    associateAllLocals() {
        this.serviceLocalsAvailable.map((serviceLocal) => {
            this.serviceLocalsAssociate.push(serviceLocal);
        });
        this.serviceLocalsAvailable = [];
    }
    desassociateAllLocals() {
        this.serviceLocalsAssociate.map((serviceLocal) => {
            this.serviceLocalsAvailable.push(serviceLocal);
        });
        this.serviceLocalsAssociate = [];
    }
    changeStatus() {
        this.subscription.add(this.userService.changeStatus(this.queryParams.id).subscribe((res) => { }, (err) => Alert.error("Ocorreu algum erro ao atualizar o status do usuário")));
    }
}
